/**
 * Manpower fulfilment and requisition routes.
 *
 * Mounted under /hr, so the paths below resolve to /hr/manpower/*.
 */
export const manpowerRoutes: any[] = [
  {
    path: 'manpower',
    name: 'hrManpower',
    redirect: { name: 'manpowerFulfilment' },
    meta: {
      title: 'routes.manpower',
      requiresAuth: true,
      breadcrumb: 'Manpower',
    },
    children: [
      {
        // The recruitment pipeline for one approved requisition. Declared
        // before 'requisitions/:id' so the more specific path wins.
        path: 'requisitions/:id/pipeline',
        name: 'manpowerRequisitionPipeline',
        component: () => import('@/modules/hr/manpowermanagement/components/CandidatePipelineBoard.vue'),
        meta: {
          title: 'Recruitment pipeline',
          requiresAuth: true,
          breadcrumb: 'Pipeline',
        },
      },
      {
        // The approver's own view: what is waiting on them, and the state of
        // the departments they answer for. Distinct from the fulfilment board,
        // which is the HR-wide picture across every norm.
        path: 'my-approvals',
        name: 'manpowerMyApprovals',
        component: () => import('@/modules/hr/manpowermanagement/components/ApproverDashboard.vue'),
        meta: {
          title: 'Waiting on you',
          requiresAuth: true,
          breadcrumb: 'Waiting on you',
        },
      },
      {
        path: 'fulfilment',
        name: 'manpowerFulfilment',
        component: () => import('@/modules/hr/manpowermanagement/components/FulfilmentDashboard.vue'),
        meta: {
          title: 'routes.manpowerFulfilment',
          requiresAuth: true,
          breadcrumb: 'Manpower Fulfilment',
        },
      },
      {
        path: 'norms',
        name: 'manpowerNorms',
        component: () => import('@/modules/hr/manpowermanagement/components/ManpowerNormList.vue'),
        meta: {
          title: 'routes.manpowerNorms',
          requiresAuth: true,
          breadcrumb: 'Manpower Norms',
        },
      },
      {
        path: 'alerts',
        name: 'manpowerAlerts',
        component: () => import('@/modules/hr/manpowermanagement/components/ShortfallAlertList.vue'),
        meta: {
          title: 'routes.manpowerAlerts',
          requiresAuth: true,
          breadcrumb: 'Shortfall Alerts',
        },
      },
      {
        path: 'requisitions',
        name: 'manpowerRequisitions',
        component: () => import('@/modules/hr/manpowermanagement/components/RequisitionList.vue'),
        meta: {
          title: 'routes.manpowerRequisitions',
          requiresAuth: true,
          breadcrumb: 'Requisitions',
        },
      },
      {
        // 'new' is declared before ':id' so it is not swallowed as an id
        path: 'requisitions/new',
        name: 'manpowerRequisitionNew',
        component: () => import('@/modules/hr/manpowermanagement/components/RequisitionForm.vue'),
        meta: {
          title: 'routes.manpowerRequisitionNew',
          requiresAuth: true,
          breadcrumb: 'Raise Requisition',
        },
      },
      {
        path: 'requisitions/:id/edit',
        name: 'manpowerRequisitionEdit',
        component: () => import('@/modules/hr/manpowermanagement/components/RequisitionForm.vue'),
        meta: {
          title: 'routes.manpowerRequisitionEdit',
          requiresAuth: true,
          breadcrumb: 'Edit Requisition',
        },
      },
      {
        path: 'requisitions/:id',
        name: 'manpowerRequisitionDetail',
        component: () => import('@/modules/hr/manpowermanagement/components/RequisitionDetail.vue'),
        meta: {
          title: 'routes.manpowerRequisitionDetail',
          requiresAuth: true,
          breadcrumb: 'Requisition',
        },
      },
    ],
  },
]

export default manpowerRoutes
